import { Helmet } from 'react-helmet-async';

const SITE_NAME = "Nistala's Group";
const DEFAULT_DESC = "Women-led, AI-powered farm-to-fork ecosystem transforming food, farming, and livelihoods across India.";
const DEFAULT_IMG = "https://customer-assets.emergentagent.com/job_soil-to-soul-2/artifacts/i9fai1ns_WhatsApp_Image_2026-03-16_at_10.39.52_AM-removebg-preview.png";

export const SEO = ({ title, description, image }) => {
  const pageTitle = title ? `${title} | ${SITE_NAME}` : `${SITE_NAME} - From Soil to Soul`;
  const desc = description || DEFAULT_DESC;
  const img = image || DEFAULT_IMG;

  return (
    <Helmet prioritizeSeoTags>
      <title>{pageTitle}</title>
      <meta name="description" content={desc} />
      <meta property="og:type" content="website" />
      <meta property="og:title" content={pageTitle} />
      <meta property="og:description" content={desc} />
      <meta property="og:image" content={img} />
      <meta property="og:site_name" content={SITE_NAME} />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={pageTitle} />
      <meta name="twitter:description" content={desc} />
      <meta name="twitter:image" content={img} />
    </Helmet>
  );
};
